export function AssetItem({
  asset,
}: {
  asset: {
    id: number;
    symbol: string;
    amount: string;
    value: string;
    change: string;
    isPositive: boolean;
    network: string;
    chainIcon: string;
    tokenIcon: string;
  };
}) {
  const fallbackIcon = (symbol: string) => {
    return (
      <span className="bitte-text-[12px] bitte-text-white bitte-font-semibold">
        {(symbol || 'B').charAt(0).toUpperCase()}
      </span>
    );
  };
  const renderAssetIcon = () => {
    return (
      <div className="bitte-w-9 bitte-h-9 bitte-rounded-full bitte-bg-[#627eea] bitte-flex bitte-items-center bitte-justify-center">
        {asset.tokenIcon ? (
          <img
            src={asset.tokenIcon}
            alt={asset.symbol}
            className="bitte-w-full bitte-h-full"
          />
        ) : (
          fallbackIcon(asset.symbol)
        )}
      </div>
    );
  };

  const renderNetworkIcon = () => {
    return (
      <div className="bitte-w-4 bitte-h-4 bitte-rounded bitte-bg-[#627eea] bitte-flex bitte-items-center bitte-justify-center bitte-mr-1">
        {asset.chainIcon ? (
          <img
            src={asset.chainIcon}
            alt={asset.network}
            className="bitte-w-full bitte-h-full"
          />
        ) : (
          fallbackIcon(asset.network)
        )}
      </div>
    );
  };

  return (
    <div className="bitte-grid bitte-grid-cols-[repeat(3,minmax(124px,1fr))] md:bitte-grid-cols-3 bitte-items-center bitte-py-3 bitte-border-b bitte-border-[#4F4848] last:bitte-border-b-0">
      <div className="bitte-flex bitte-items-center bitte-gap-3">
        {renderAssetIcon()}
        <div>
          <div className="bitte-text-sm bitte-font-bold bitte-mb-2">
            {asset.symbol}
          </div>
          <div className="bitte-text-xs bitte-text-[#858585] bitte-flex bitte-items-center bitte-font-semibold">
            {renderNetworkIcon()}
            <div>{asset.network}</div>
          </div>
        </div>
      </div>
      <div className="bitte-text-right bitte-flex bitte-items-center bitte-justify-end bitte-gap-1">
        <div className="bitte-text-sm bitte-text-mb-white-100">
          {asset.amount}
        </div>
        <div className="bitte-text-xs bitte-text-[#858585]">{asset.symbol}</div>
      </div>
      <div className="bitte-text-right">
        <div className="bitte-text-sm bitte-mb-2">{asset.value}</div>
        <div
          className={`bitte-text-xs ${asset.isPositive ? 'bitte-text-[#4ADE80]' : 'bitte-text-[#F87171]'}`}
        >
          {asset.change}
        </div>
      </div>
    </div>
  );
}
